import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { not } from 'ramda';
import { useBreakpointsContext } from '../store/BreakpointsContext';

export const useCardLeft = () => {
  const { isDesktop } = useBreakpointsContext();

  const [visibility, setVisibility] = useState(false);

  const isVisible = useMemo(() => {
    return isDesktop || visibility;
  }, [visibility]);

  const toggleVisibility = useCallback(() => setVisibility(not), []);

  const containerRef = useRef(null);

  useEffect(() => {
    const func = (event) => {
      const clickedSomethingOtherThanCard = () => {
        if (!containerRef.current) return false;
        if (containerRef.current.isSameNode(event.target)) return true;
        return !containerRef.current.contains(event.target);
      };
      if (clickedSomethingOtherThanCard()) {
        setVisibility(false);
      }
    };
    if (visibility && !isDesktop) {
      document.addEventListener('click', func);
    }

    return () => {
      document.removeEventListener('click', func);
    };
  }, [visibility, isDesktop]);

  return { isVisible, setVisibility, toggleVisibility, containerRef };
};
